// extracted by mini-css-extract-plugin
export var leftAlign = "_3w-2";
export var popper = "_3w-0";
export var subtitle = "_3w-1";